import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('tax-accountant/dashboard/statistics')
  }
}

export default DashboardService
